export enum ConversationStatusEnum {
  Sent = 'SENT',
  Replied = 'REPLIED',
  New = 'NEW',
}
